/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import getDefaultSearchHistories from "./default_search_histories.js";

export default {
  SET_SEARCH_HISTORIES(state, data) {
    state.histories = getDefaultSearchHistories().concat(data || []);
    state.origin = data;
  },
  REMOVE_HISTORY(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const userIndex = state.histories.findIndex((u) => u.id === item);
        state.histories.splice(userIndex, 1);
      });
    } else {
      const userIndex = state.histories.findIndex((u) => u.id === itemId);
      state.histories.splice(userIndex, 1);

      const originIndex = state.origin.findIndex((u) => u.id === itemId);
      state.origin.splice(originIndex, 1);
    }
  },
  ADD_HISTORY(state, history) {
    state.histories.push(history);
    state.origin.push(history);
  },

  SET_STUDENT_FILTER(state, data) {
    state.studentFilter = data?.items || [];
    state.pagination = data.pagination ? data.pagination : {};
  },
  ADD_STUDENT_FILTER(state, data) {
    state.studentFilter.push(data);
  },
  UPDATE_STUDENT_FILTER(state, data) {
    const index = state.studentFilter.findIndex((u) => u.id === data.id);
    if (index >= 0) {
      state.studentFilter.splice(index, 1, data);
    }
  },

  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};
